import React from 'react'

import {  Footer, Header } from '../components/layout'
import { C_BlogDetails } from '../components/Charities'

const C_BlogDetails_page = () => {

  return (
     <div className='bg-light-primary dark:bg-dark-primary'
  
     >
        <Header />
   <C_BlogDetails />
        <Footer />
        </div>
  )
}

export default C_BlogDetails_page